// 字段配置类型定义

export interface FieldConfig {
  key: string
  labelZhCN: string
  labelEnUS: string
  labelJaJP: string
  fieldType: 'Text' | 'Number' | 'Attachment' | 'Object'
  required?: boolean
  primary?: boolean
  hidden?: boolean
}

export interface FormItemConfig extends FieldConfig {
  component: 'FieldSelect' | 'Input' | 'Textarea'
  supportType: string[] // ['Text'], ['Attachment'], etc.
}

export interface ResultPropertyConfig extends FieldConfig {
  // resultType 专用配置
}

export interface TemplateConfig {
  formItems: FormItemConfig[]
  resultProperties: ResultPropertyConfig[]
  languages: ('zh-CN' | 'en-US' | 'ja-JP')[]
}

// 默认配置
export const DEFAULT_TEMPLATE_CONFIG: TemplateConfig = {
  formItems: [
    {
      key: 'input',
      labelZhCN: '输入内容',
      labelEnUS: 'Input',
      labelJaJP: '入力',
      fieldType: 'Text',
      component: 'FieldSelect',
      supportType: ['Text'],
      required: true,
    }
  ],
  resultProperties: [
    {
      key: 'id',
      labelZhCN: 'id',
      labelEnUS: 'id',
      labelJaJP: 'id',
      fieldType: 'Text',
      hidden: true,
    },
    {
      key: 'output',
      labelZhCN: '输出结果',
      labelEnUS: 'Output',
      labelJaJP: '出力',
      fieldType: 'Text',
      primary: true,
    }
  ],
  languages: ['zh-CN', 'en-US', 'ja-JP']
}
